import React from 'react'
import { useAddBoard } from './useAddBoard'
import { Field, Form } from '@ztechapps/webui.form'
import { TextAreaInput, TextInput } from '@ztechapps/webui.input'
import { SaveCancelButtons } from '@ztechapps/webui.button'

export const AddBoardModalContent = () => {
  const { onSubmit, validate, onReset } = useAddBoard()

  return (
    <Form initialValues={{ name: 'My cool favorite name' }} onSubmit={onSubmit} onReset={onReset} validate={validate}>
      {({ isValid, isSubmitting }) => (
        <div className="flex-column d-flex justify-content-between   h-100 ">
          <div>
            <h3 className="text-center  ">Save your item to a new favorite</h3>
            <hr />
            <Field component={TextInput} name={'name'} label="Board name" placeholder="My new cool favorite" />

            <Field
              component={TextAreaInput}
              name={'remarks'}
              label="Remarks"
              help="Put some descriptive information about this favorite."
            />
          </div>

          <div className="d-flex justify-content-between   mt-4 ">
            <div />
            <SaveCancelButtons cancelType="reset" saveType="submit" isBusy={isSubmitting} disabled={!isValid} />
          </div>
        </div>
      )}
    </Form>
  )
}
